import gachapon from '../JSON/Gachapon.json';

export default id =>
  gachapon.reduce(
    (acc, { name, items }) => (!items.includes(id) ? acc : [...acc, name]),
    [],
  );
